import React, {useEffect} from 'react';
import {Row, Col} from 'react-bootstrap';
import {useDispatch, useSelector} from 'react-redux';
import {get} from 'lodash';
import {sagaActions} from './redux/saga';

const EntitySummary = ({entityId, entityType}) => {
  const dispatch = useDispatch();
  const entitySummary = useSelector((state) => state.entity.entitySummary);
  useEffect(() => {
    dispatch({
      type: sagaActions.FETCH_ENTITY_SUMMARY,
      payload: {
        entityId,
      },
    });
  }, [entityId, entityType]);
  return (
    <Row className="mt-3">
      <Col>
        <h6>{entityType} Summary</h6>
        <div
          style={{backgroundColor: '#fff', padding: '0px 10px'}}
          className="border border-dark mb-2"
        >
          <Row className="border-dark border-bottom">
            <Col className="font-weight-bold">
              GREENHOUSE GAS EMISSIONS (t CO2)
            </Col>
          </Row>
          <Row className="border-dark border-bottom">
            <Col className="border-dark border-right font-weight-bold">
              Scope1
            </Col>
            <Col className="border-dark border-right font-weight-bold">
              Scope2
            </Col>
            <Col className="font-weight-bold">Total of Scope1 and Scope2</Col>
          </Row>
          <Row className="">
            <Col className="border-dark border-right">
              {get(entitySummary, 'scope1', '-')}
            </Col>
            <Col className="border-dark border-right">
              {get(entitySummary, 'scope2', '-')}
            </Col>
            <Col>{get(entitySummary, 'scopeTotal', '-')}</Col>
          </Row>
        </div>
        <div
          style={{backgroundColor: '#fff', padding: '0px 10px'}}
          className="border border-dark"
        >
          <Row className="border-dark border-bottom">
            <Col className="font-weight-bold">
              ENERGY PRODUCED AND ENERGY CONSUMED (MMBtu)
            </Col>
          </Row>
          <Row className="border-dark border-bottom">
            <Col className="border-dark border-right font-weight-bold">
              Energy Consumed Total
            </Col>
            <Col className="border-dark border-right font-weight-bold">
              Energy Produced Total
            </Col>
            <Col className="font-weight-bold">Energy Consumed Net</Col>
          </Row>
          <Row className="">
            <Col className="border-dark border-right">
              {get(entitySummary, 'energyConsumed', '-')}
            </Col>
            <Col className="border-dark border-right">
              {get(entitySummary, 'energyProduced', '-')}
            </Col>
            <Col>{get(entitySummary, 'energyConsumedNet', '-')}</Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default EntitySummary;
